// extracted by mini-css-extract-plugin
export default {"List-ocean-Item-primary":"theme-ocean_List-ocean-Item-primary__Ww6Dt","List-ocean-Item-secondary":"theme-ocean_List-ocean-Item-secondary__g2O0a"};